import ApiService from "@/common/api.service";
import AuthService from "@/common/auth.service";
import { LOGIN, REGISTER, DATA_USER } from "../actions.type";
import { SET_AUTH } from "../mutations.type";

const state = {
  user: AuthService.getUser()
};

const getters = {
  user(state) {
    return state.user;
  }
};

const actions = {
  [LOGIN](context, credentials) {
    return ApiService.post("auth/login", credentials).then(data => {
      console.log(data);
      context.commit(SET_AUTH, data.user);
      return Promise.resolve(data);
    });
  },

  [REGISTER](context, credentials) {
    return ApiService.post("auth/register", { user: credentials }).then(
      data => {
        context.commit(SET_AUTH, data.user);
        return Promise.resolve(data);
      }
    );
  },

  [DATA_USER]() {
    return ApiService.get("auth/dataUser");
  }
};

const mutations = {
  [SET_AUTH](state, user) {
    state.user = user;

    ApiService.setHeader();
    AuthService.saveToken(state.user.token);
    AuthService.saveUser(state.user);
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
